import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import axios from 'axios';
import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { convertFirstCharacterToUppercase } from '../../../helpers/convertStringToUpperLowerCase';
import MuiSnackbar from '../../common/MuiSnackbar';

const ManageSubscription = ({ user, isResolved }) => {
  const [isCheckoutInProgress, setIsCheckoutInProgress] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  const handleSubscription = async () => {
    const allowed = ['standard', 'premium', 'professional'];
    if (!allowed.includes(user.role)) {
      return;
    }
    setIsCheckoutInProgress(true);
    try {
      const { data } = await axios({
        'Content-Type': 'application/json',
        method: 'POST',
        url: '/api/v1/bookings/handle-subscription-session',
      });
      window.location.href = data.sessionUrl;
    } catch (err) {
      setAlertMessage(err.response?.data?.message || 'Something went wrong. Please try again.');
      setSnackbarOpen(true);
      setIsCheckoutInProgress(false); // This is inside catch block because it sets to true before page redirect.
    }
  };

  return (
    <div className="account-section">
      <MuiSnackbar open={snackbarOpen} setOpen={setSnackbarOpen} severity="error" alertMessage={alertMessage} />
      <h3>Subscription Details</h3>
      <div className="subscriptionDetails">
        <TextField
          sx={{
            width: 400, // lock width if needed
          }}
          size="small"
          label="Current subscription plan:"
          variant="outlined"
          disabled={true}
          readOnly
          value={convertFirstCharacterToUppercase(user.role) + ' Plan'}
        />
        {isResolved && user && (
          <Button
            variant="contained"
            size="large"
            onClick={handleSubscription}
            disabled={isCheckoutInProgress || user.role === 'basic'}
            sx={{
              width: 400, // lock width if needed
            }}
          >
            {isCheckoutInProgress ? (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  height: '100%',
                }}
              >
                <CircularProgress size={24} />
              </Box>
            ) : (
              'Manage your subscription'
            )}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ManageSubscription;
